<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ $t('version_form.title') }}</p>
      <button class="delete" @click="$emit('close')"></button>
    </header>
    <section class="modal-card-body">
      <b-field :label="$t('version_form.version')">
        <b-input v-model="localVersion.version"></b-input>
      </b-field>
      <b-field :label="$t('version_form.date')">
        <b-datepicker
          :placeholder="$t('version_form.date_placeholder')"
          v-model="localVersion.date"
        ></b-datepicker>
      </b-field>
      <b-field :label="$t('version_form.section')">
        <b-select
          :placeholder="$t('version_form.section_placeholder')"
          v-model="localVersion.section"
        >
          <option value="fixes">{{ $t('version_page.fixes') }}</option>
          <option value="features">{{ $t('version_page.features') }}</option>
          <option value="removals">{{ $t('version_page.removals') }}</option>
        </b-select>
      </b-field>
      <b-field :label="$t('version_form.details')">
        <b-input v-model="localVersion.details" type="textarea"></b-input>
      </b-field>
      <b-field :label="$t('version_form.tag')">
        <b-input v-model="localVersion.tag"></b-input>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <b-button :label="$t('common.close')" @click="$emit('close')"></b-button>
      <b-button
        :label="$t('common.save')"
        type="is-success"
        @click="saveVersion"
      ></b-button>
    </footer>
  </div>
</template>

<script>
export default {
  props: ['version'],
  data() {
    return {
      localVersion: { ...this.version },
    };
  },
  methods: {
    saveVersion() {
      this.$emit('save', this.localVersion);
      this.$emit('close');
    },
  },
};
</script>
